import * as React from "react";
import styled, { css } from "styled-components";
import SwiperCore, {
  Navigation,
  Autoplay
} from "swiper";
import {
  Swiper,
  SwiperSlide
} from "swiper/react";

import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import WidgetContainer from "src/library/components/WidgetContainer/WidgetContainer";

import {
  IPromotion,
  PromotionLinkType
} from "../api/promotions.api";
import { useDropPromotions } from "../context/DropPromotionsContext";
import PromotionBanner from "./PromotionBanner";

// install Swiper modules
SwiperCore.use([ Navigation, Autoplay ]);

const DashboardPromotionsBanner: React.ReactFCWithChildren = () => {
  const { promotions } = useDropPromotions();

  const buildPromotionsLink = React.useCallback((promotion: IPromotion) => {
    switch (promotion.linkType) {
      case PromotionLinkType.Product:
        return `/products/${promotion.productId || ""}`;
      case PromotionLinkType.Category:
        return `/products?category=${promotion.categoryId}`;
      case PromotionLinkType.Raw:
        return promotion.linkUrl || "/products";
      default:
        return "/products";
    }
  }, []);

  if (!promotions.length) {
    return null;
  }

  return (
    <WidgetContainer title="Latest offers">
      <PromotionsBannerWrapper>
        <PromotionsBannerSwiper
          spaceBetween={50}
          slidesPerView="auto"
          autoplay={{ delay: 10000 }}
          navigation={{
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev"
          }}
        >
          {!!promotions.length &&
          promotions.map(promotion => {
            return (
              <SwiperSlide key={`promotion-${promotion.id}`}>
                <a
                  href={buildPromotionsLink(promotion)}
                  target={promotion.linkUrl ? "_blank" : ""}
                  rel="noreferrer"
                >
                  <PromotionBanner {...promotion} />
                </a>
              </SwiperSlide>
            );
          })}

          <div className="swiper-navigation">
            <div className="swiper-nav-button swiper-prev">
              <Icon
                icon={Icons.CHEVRONLEFT}
                size={40}
              />
            </div>

            <div className="swiper-nav-button swiper-next">
              <Icon
                icon={Icons.CHEVRONRIGHT}
                size={40}
              />
            </div>
          </div>
        </PromotionsBannerSwiper>
      </PromotionsBannerWrapper>
    </WidgetContainer>
  );
};

export default DashboardPromotionsBanner;

const PromotionsBannerWrapper = styled.div`
  ${() => css`
    width: 100%;
  `}
`;

const PromotionsBannerSwiper = styled(Swiper)`
  display: block;
  width: 100%;
  height: 240px;
  position: relative;

  .swiper-wrapper {
    display: flex;
    align-items: flex-start;
    height: 100%;
  }

  .swiper-navigation {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    left: 0;

    .swiper-nav-button {
      &.swiper-button-disabled {
        opacity: 0;
      }
    }

    .swiper-next {
      position: absolute;
      right: 0;
    }

    .swiper-prev {
      position: absolute;
      left: 0;
    }
  }
`;
